/**
 * Standard API error response structure
 * Based on RFC 7807 Problem Details format
 */
export type ApiError = {
    message: string;
    type: string;
    status: number;
    title: string;
    detail?: string;
    instance?: string;
};

/**
 * Known API error types (URNs)
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ApiErrorType = {
    ValidationError: 'urn:agreement:status:validationError:v1',
    NotFound: 'urn:agreement:status:notFound:v1',
    Conflict: 'urn:agreement:status:conflict:v1',
    Unauthorized: 'urn:agreement:status:unauthorized:v1',
    Forbidden: 'urn:agreement:status:forbidden:v1',
    InternalError: 'urn:agreement:status:internalError:v1'
} as const;

export type ApiErrorTypeValue = (typeof ApiErrorType)[keyof typeof ApiErrorType];
